import type { IframeHTMLAttributes, Ref } from "react";
import { Settings2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAdsAllowed } from "@/lib/consent";

export function VideoConsentPrompt() {
  return <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-background px-3 text-center">
    <p className="max-w-sm text-sm text-muted-foreground">Le lecteur externe nécessite votre accord « Publicité et lecteurs externes ».</p>
    <Button variant="outline" size="sm" onClick={() => window.dispatchEvent(new Event("cd-consent-open"))}><Settings2 aria-hidden="true" />Gérer les cookies</Button>
  </div>;
}

/** Aucun iframe tiers dans le DOM avant accord ; démonté au retrait. */
export function ConsentVideoFrame(props: IframeHTMLAttributes<HTMLIFrameElement> & { ref?: Ref<HTMLIFrameElement> }) {
  const allowed = useAdsAllowed();
  if (!allowed) return <VideoConsentPrompt />;
  return <iframe {...props} />;
}